function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1928(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.81,
    height: 14.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0876923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 7.07
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.14,
    width: 23.81,
    height: 19.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7314285714285718
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 23.700000000000003
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.27,
    width: 23.81,
    height: 20.9,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9857142857142853
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 43.72
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.17,
    width: 23.81,
    height: 28.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 68.44500000000001
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.72,
    width: 23.81,
    height: 29.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 97.485
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.25,
    width: 23.81,
    height: 30.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 127.28
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.31,
    width: 23.81,
    height: 30.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 157.565
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.82,
    width: 23.81,
    height: 30.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 188.295
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.77,
    width: 23.81,
    height: 32.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.762
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 220.22500000000002
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 236.68,
    width: 23.81,
    height: 35.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4014285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 254.645
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 272.62,
    width: 23.81,
    height: 36.02,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 290.63
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.64,
    width: 23.81,
    height: 36.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 326.695
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 344.75,
    width: 23.81,
    height: 36.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4014285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 363.115
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 381.49,
    width: 23.81,
    height: 36.91,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4014285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 399.945
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.4,
    width: 23.81,
    height: 37.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 437.21
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.02,
    width: 23.81,
    height: 38.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.381
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 475.365
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.71,
    width: 23.81,
    height: 39.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 514.3199999999999
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.94,
    width: 23.81,
    height: 40.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 554.22
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 574.5,
    width: 23.81,
    height: 41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 595
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 615.5,
    width: 23.81,
    height: 41.89,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 636.445
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 657.4,
    width: 23.81,
    height: 42.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.905,
    y: 678.6999999999999
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 0,
    width: 28.78,
    height: 35.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.2,
    y: 17.695
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.59,
    y: 0,
    width: 29.62,
    height: 35.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.962
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.4,
    y: 17.695
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.21,
    y: 0,
    width: 30.04,
    height: 35.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.22999999999999,
    y: 17.695
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.25,
    y: 0,
    width: 30.16,
    height: 35.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.33,
    y: 17.695
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.41,
    y: 0,
    width: 30.4,
    height: 35.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.60999999999999,
    y: 17.695
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.81,
    y: 0,
    width: 30.7,
    height: 35.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.16,
    y: 17.695
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.51,
    y: 0,
    width: 30.76,
    height: 35.39,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.152
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.89,
    y: 17.695
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.26,
    y: 0,
    width: 32.37,
    height: 35.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.445,
    y: 17.695
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.64,
    y: 0,
    width: 32.55,
    height: 35.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6499999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.91499999999996,
    y: 17.695
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.19,
    y: 0,
    width: 33.33,
    height: 35.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.761428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.855,
    y: 17.695
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 0,
    width: 33.57,
    height: 35.39,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.305,
    y: 17.695
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.09,
    y: 0,
    width: 33.93,
    height: 35.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.05499999999995,
    y: 17.695
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.02,
    y: 0,
    width: 34.41,
    height: 35.39,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.30125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.22499999999997,
    y: 17.695
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.43,
    y: 0,
    width: 36.5,
    height: 35.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.68,
    y: 17.695
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.93,
    y: 0,
    width: 37.22,
    height: 35.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.54,
    y: 17.695
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.15,
    y: 0,
    width: 37.52,
    height: 35.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.91,
    y: 17.695
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.67,
    y: 0,
    width: 37.58,
    height: 35.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.42375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.4599999999999,
    y: 17.695
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.25,
    y: 0,
    width: 38.54,
    height: 35.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.52,
    y: 17.695
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.79,
    y: 0,
    width: 38.6,
    height: 35.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.0899999999999,
    y: 17.695
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.39,
    y: 0,
    width: 39.61,
    height: 35.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.1949999999999,
    y: 17.695
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 35.39,
    width: 39.58,
    height: 35.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 53.31
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 71.23,
    width: 39.58,
    height: 36.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0183333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 89.285
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 107.34,
    width: 39.58,
    height: 36.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 125.555
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 143.77,
    width: 39.58,
    height: 36.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 162.09
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 180.41,
    width: 39.58,
    height: 37.18,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.196666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 199
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 217.59,
    width: 39.58,
    height: 37.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.73375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 236.525
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 255.46,
    width: 39.58,
    height: 38.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 274.505
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 293.55,
    width: 39.58,
    height: 38.19,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.243333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 312.645
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 331.74,
    width: 39.58,
    height: 39.53,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.588333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 351.505
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 371.28,
    width: 39.58,
    height: 39.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.654285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 391.09999999999997
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 410.92,
    width: 39.58,
    height: 39.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.654285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 430.82
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 450.72,
    width: 39.58,
    height: 40.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 470.83500000000004
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 490.94,
    width: 39.58,
    height: 41.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 511.59
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 532.24,
    width: 39.58,
    height: 41.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 553.105
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 573.97,
    width: 39.58,
    height: 41.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 594.86
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 615.75,
    width: 39.58,
    height: 41.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 636.745
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 657.74,
    width: 39.58,
    height: 42.26,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.397777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.599999999999994,
    y: 678.87
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 35.39,
    width: 39.22,
    height: 43.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.843999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 83,
    y: 56.93
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.61,
    y: 35.39,
    width: 39.71,
    height: 43.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.618333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.465,
    y: 56.93
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 35.39,
    width: 40.3,
    height: 43.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.47,
    y: 56.93
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.62,
    y: 35.39,
    width: 41.28,
    height: 43.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.897142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.26,
    y: 56.93
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.91,
    y: 35.39,
    width: 41.38,
    height: 43.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.276
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.6,
    y: 56.93
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.29,
    y: 35.39,
    width: 41.97,
    height: 43.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.27500000000003,
    y: 56.93
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.26,
    y: 35.39,
    width: 42.17,
    height: 43.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.024285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.34499999999997,
    y: 56.93
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.43,
    y: 35.39,
    width: 42.27,
    height: 43.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.045000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.565,
    y: 56.93
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.7,
    y: 35.39,
    width: 42.86,
    height: 43.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.13,
    y: 56.93
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.55,
    y: 35.39,
    width: 43.4,
    height: 43.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.25,
    y: 56.93
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.95,
    y: 35.39,
    width: 44.04,
    height: 43.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.96999999999997,
    y: 56.93
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.99,
    y: 35.39,
    width: 44.23,
    height: 43.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.105,
    y: 56.93
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 566.22,
    y: 35.39,
    width: 44.28,
    height: 43.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.36,
    y: 56.93
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.5,
    y: 35.39,
    width: 44.48,
    height: 43.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.74,
    y: 56.93
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 654.98,
    y: 35.39,
    width: 45.02,
    height: 43.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.154285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.49,
    y: 56.93
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 78.47,
    width: 45.79,
    height: 42.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.556000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 99.86
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 121.25,
    width: 45.79,
    height: 42.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 142.665
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 164.08,
    width: 45.79,
    height: 43.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.217142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 185.84
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 207.6,
    width: 45.79,
    height: 43.57,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 229.385
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 251.16,
    width: 45.79,
    height: 43.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2683333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 272.965
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 294.77,
    width: 45.79,
    height: 43.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 316.66999999999996
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 338.57,
    width: 45.79,
    height: 43.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 360.53999999999996
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 382.51,
    width: 45.79,
    height: 44.03,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 404.525
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 426.53,
    width: 45.79,
    height: 44.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 448.775
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 471.03,
    width: 45.79,
    height: 45.32,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 493.69
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 516.35,
    width: 45.79,
    height: 45.42,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.488571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 539.0600000000001
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 561.76,
    width: 45.79,
    height: 45.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.541428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 584.745
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 607.73,
    width: 45.79,
    height: 45.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 630.715
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.39,
    y: 653.71,
    width: 45.79,
    height: 46.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.541428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.285,
    y: 676.855
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 78.47,
    width: 45.68,
    height: 46.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.525714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.02,
    y: 101.785
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.86,
    y: 78.47,
    width: 45.91,
    height: 46.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.651666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.815,
    y: 101.785
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.77,
    y: 78.47,
    width: 46,
    height: 46.63,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.571428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.77,
    y: 101.785
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.77,
    y: 78.47,
    width: 46.23,
    height: 46.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.622999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.885,
    y: 101.785
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.99,
    y: 78.47,
    width: 48.04,
    height: 46.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.661428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.01,
    y: 101.785
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.04,
    y: 78.47,
    width: 48.91,
    height: 46.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.495,
    y: 101.785
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.94,
    y: 78.47,
    width: 49,
    height: 46.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.44,
    y: 101.785
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.94,
    y: 78.47,
    width: 50.99,
    height: 46.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.435,
    y: 101.785
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.94,
    y: 78.47,
    width: 51.31,
    height: 46.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.771666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.595,
    y: 101.785
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.25,
    y: 78.47,
    width: 52.81,
    height: 46.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.771666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.655,
    y: 101.785
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.06,
    y: 78.47,
    width: 52.95,
    height: 46.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.771666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.535,
    y: 101.785
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.01,
    y: 78.47,
    width: 52.99,
    height: 46.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.661428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.505,
    y: 101.785
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 125.1,
    width: 54.12,
    height: 47.77,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.824285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 148.98499999999999
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 172.88,
    width: 54.12,
    height: 48.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.881428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 196.965
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 221.04,
    width: 54.12,
    height: 48.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 245.435
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 269.83,
    width: 54.12,
    height: 48.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.11875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 294.305
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 318.78,
    width: 54.12,
    height: 49.38,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.876000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 343.46999999999997
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 368.16,
    width: 54.12,
    height: 52.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.548
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 394.53000000000003
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 420.9,
    width: 54.12,
    height: 53.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 447.525
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 474.16,
    width: 54.12,
    height: 53.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.751999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 501.04
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 527.92,
    width: 54.12,
    height: 55.99,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.731428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 555.915
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 583.91,
    width: 54.12,
    height: 57.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 612.5899999999999
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.18,
    y: 641.27,
    width: 54.12,
    height: 58.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.24,
    y: 670.635
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 125.1,
    width: 58.08,
    height: 55.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.8725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.32999999999998,
    y: 152.845
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.37,
    y: 125.1,
    width: 58.42,
    height: 55.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.58,
    y: 152.845
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.79,
    y: 125.1,
    width: 58.8,
    height: 55.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.19,
    y: 152.845
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.6,
    y: 125.1,
    width: 58.96,
    height: 55.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.08000000000004,
    y: 152.845
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.55,
    y: 125.1,
    width: 59.49,
    height: 55.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.295,
    y: 152.845
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.04,
    y: 125.1,
    width: 59.95,
    height: 55.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.93625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.01500000000004,
    y: 152.845
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.99,
    y: 125.1,
    width: 59.95,
    height: 55.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.965,
    y: 152.845
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.94,
    y: 125.1,
    width: 61.47,
    height: 55.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.098
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.6750000000001,
    y: 152.845
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.41,
    y: 125.1,
    width: 61.59,
    height: 55.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.549
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.2049999999999,
    y: 152.845
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 180.59,
    width: 64.5,
    height: 54.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.715714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 207.595
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 234.6,
    width: 64.5,
    height: 54.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 261.98
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 289.36,
    width: 64.5,
    height: 55.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.865714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 316.89
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 344.42,
    width: 64.5,
    height: 57.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 373.41
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 402.39,
    width: 64.5,
    height: 58.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 431.395
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 460.41,
    width: 64.5,
    height: 58.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 489.61
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 518.81,
    width: 64.5,
    height: 59.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 548.39
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 577.97,
    width: 64.5,
    height: 60.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 608.4200000000001
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.29,
    y: 638.87,
    width: 64.5,
    height: 61.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.732857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.54,
    y: 669.4350000000001
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 180.59,
    width: 64.47,
    height: 61.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.025,
    y: 211.54500000000002
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.27,
    y: 180.59,
    width: 64.64,
    height: 61.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.844285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.59,
    y: 211.54500000000002
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.91,
    y: 180.59,
    width: 67.82,
    height: 61.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.82000000000005,
    y: 211.54500000000002
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.73,
    y: 180.59,
    width: 68.1,
    height: 61.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.73875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.78000000000003,
    y: 211.54500000000002
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.83,
    y: 180.59,
    width: 68.71,
    height: 61.91,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.844285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.185,
    y: 211.54500000000002
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561.55,
    y: 180.59,
    width: 68.95,
    height: 61.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.878888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.025,
    y: 211.54500000000002
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.5,
    y: 180.59,
    width: 69.5,
    height: 61.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.73875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.25,
    y: 211.54500000000002
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 242.5,
    width: 70.65,
    height: 61.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 273.28
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 304.07,
    width: 70.65,
    height: 62.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 335.36
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 366.65,
    width: 70.65,
    height: 63.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 398.585
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 430.52,
    width: 70.65,
    height: 64.32,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 462.67999999999995
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 494.84,
    width: 70.65,
    height: 67.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.38125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 528.365
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 561.89,
    width: 70.65,
    height: 67.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 595.76
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.79,
    y: 629.63,
    width: 70.65,
    height: 70.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.115,
    y: 664.815
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 242.5,
    width: 77.24,
    height: 65.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.355714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.06,
    y: 275.245
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.68,
    y: 242.5,
    width: 79.44,
    height: 65.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.355714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.4,
    y: 275.245
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.12,
    y: 242.5,
    width: 81.12,
    height: 65.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.276666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.68,
    y: 275.245
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.24,
    y: 242.5,
    width: 81.6,
    height: 65.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.097999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.04,
    y: 275.245
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.85,
    y: 242.5,
    width: 82.15,
    height: 65.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.9250000000001,
    y: 275.245
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 308,
    width: 79.03,
    height: 73.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.4525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.955,
    y: 344.905
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 381.81,
    width: 79.03,
    height: 75.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.347777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.955,
    y: 419.375
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 456.94,
    width: 79.03,
    height: 76.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.676666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.955,
    y: 494.97
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 533,
    width: 79.03,
    height: 82.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.955,
    y: 574.475
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 615.95,
    width: 79.03,
    height: 84.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.955,
    y: 657.975
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 308,
    width: 72.12,
    height: 94.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.424000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.54,
    y: 355.325
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.6,
    y: 308,
    width: 78.21,
    height: 94.65,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.642
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.70500000000004,
    y: 355.325
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.81,
    y: 308,
    width: 82.15,
    height: 94.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.885,
    y: 355.325
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.96,
    y: 308,
    width: 90.04,
    height: 94.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.862857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.98,
    y: 355.325
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 402.65,
    width: 115.56,
    height: 80.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.26,
    y: 442.65999999999997
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 482.67,
    width: 115.56,
    height: 85.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.26,
    y: 525.465
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 568.26,
    width: 115.56,
    height: 131.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.26,
    y: 634.13
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 159,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.04,
    y: 402.65,
    width: 206.96,
    height: 110.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.81857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.52,
    y: 458.015
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 160,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.04,
    y: 513.38,
    width: 206.96,
    height: 186.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.103333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.52,
    y: 606.69
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1928);
export default __webpack_public_path__ + "static/media/1928.5b3f8359ea519fe41f46eb0eeff58a4d.svg";
export { ForwardRef as ReactComponent };